import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages.js';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';

import chevronDoubleLeft from '../../../assets/icons/chevron-double-left.svg';

const AboutPblItem = ({ clang, data, match, showBackButton }) => {
    return (
        <div className="about-pbl__item about-pbl__subpage">
            {showBackButton &&
                <Link
                    to={`/about/${match.params.type}`}
                    title={lang[clang].back}
                    className="back-button">
                    <img src={chevronDoubleLeft} alt="" className="back-button__img" />
                    {lang[clang].back}
                </Link>}

            <h3 dangerouslySetInnerHTML={{__html: data.title.rendered}} className="about-pbl__item-title"></h3>

            <div className="about-pbl__subpage-content-container">
                {/*<img src={data.better_featured_image.source_url} alt="" />*/}
                <div dangerouslySetInnerHTML={{__html: data.content.rendered}}></div>
            </div>

            <Link to={`${data.acf.queries_link_results}`} className="about-pbl__item-results--btn">
                {lang[clang].about_pbl.query_results}
                <span className="about-pbl__item-results--btn-img"></span>
            </Link>
        </div>
    );
};

AboutPblItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(AboutPblItem));



// WEBPACK FOOTER //
// ./src/components/about/subpages/AboutPblItem.js